/**
 * 
 */
import * as mapvgl from 'mapvgl'
import AppMap from '@/components/screen28896/map-zone/AppMap.js'
import {
  geoPolygon
} from '@/common/MapTool.js'
import geoTowns from '@/components/geo-towns.js'
import volumnTowns from '@/components/volumn-towns.js'

function IndexMap() {
  var vue

  /**
   * 开始显示整个县域的状况
   * @param {*} v 
   */
  this.start = function (v) {
    vue = v
    const {
      map,
      view,
      BMapGL
    } = AppMap
    view.removeAllLayers()
    AppMap.fly2(117.18, 32.12, 12).then(() => {
      // 乡镇轮廓
      const townsLyr = new mapvgl.PolygonLayer({
        fillColor: 'rgba(111, 160, 191, 0.5)', // 填充颜色
        lineColor: '#6fa0bf',
        lineWidth: 2,
        lineJoin: 'miter',
        enablePicked: true, // 是否可以拾取
        selectedIndex: -1, // 选中项
        selectedColor: 'rgba(111, 160, 191, 0.8)', // 选中项颜色
        autoSelect: true, // 根据鼠标位置来自动设置选中项
        onClick: (e) => {
          if (e && e.dataItem) {
            const code = e.dataItem.properties.Code
            if ('112340121100000' === code) {
              vue.$router.push(`/screen28896/parks`)
            } else {
              vue.$router.push(`/screen28896/towns/${code}`)
            }
          }
        }
      })
      view.addLayer(townsLyr)
      townsLyr.setData(geoTowns.features)

      // 产量柱图和文字标签
      const features = []
      for (const i in volumnTowns) {
        const r = volumnTowns[i]
        features.push(Object.assign(geoPolygon(r.anchor, 0.5, 4), {
          properties: {
            height: r.volumn >= 20000 ? r.volumn * 0.05 + 4000 : r.volumn
          },
        }))
        const lbl = new BMapGL.Label(
          `
            <p class="town-name">${r.name}</p>
            <p class="town-volumn">${r.volumn} 亩</p>
            `, {
            position: new BMapGL.Point(r.anchor[0], r.anchor[1]),
            offset: new BMapGL.Size(10, -20)
          })
        lbl.setStyle({
          borderColor: 'rgba(0,0,0,0)',
          backgroundColor: 'rgba(0,0,0,0)',
        })
        map.addOverlay(lbl)
      }
      // 柱状图
      const volumnsLyr = new mapvgl.ShapeLayer({
        color: '#cf1505', // 柱状图颜色
        enablePicked: false, // 是否可以拾取
        riseTime: 900
      })
      view.addLayer(volumnsLyr)
      volumnsLyr.setData(features)
    })
  }


  /**
   * 销毁之前绘制的所有内容，通常在页面切换时调用
   */
  this.destroy = function () {
    const {
      map,
      view
    } = AppMap
    view.removeAllLayers()
    map.clearOverlays()
  }

}

export default new IndexMap()



// WEBPACK FOOTER //
// ./src/components/screen28896/map-zone/mask/IndexMap.js